import { createSelector } from 'reselect';
import { get } from 'lodash';

import { decodeScreenerTypes, getNodeStatements } from '../screening';

const selectQuestionnaireQuestions = (state) =>
  get(state, 'questionnairePage.surveyDetailsExtended.questions', []);
export const selectQuestionnaireLogicQl = (state) =>
  get(state, 'questionnairePage.questionnaireLogic.ql', {});

/**
 * `{ [questionRefId]: { [itemKey]: screenerType } }` for every screening
 * question, read from its screening rules.
 */
export const makeSelectScreenerTypes = createSelector(
  selectQuestionnaireQuestions,
  selectQuestionnaireLogicQl,
  (questions, ql) =>
    Object.fromEntries(
      questions
        .filter(({ isScreening }) => isScreening)
        .map((node) => [
          node.refId,
          decodeScreenerTypes({
            node,
            statements: getNodeStatements(ql, node.refId),
          }),
        ]),
    ),
);
